import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo, useState, useEffect } from 'react';
import { validateNumber } from 'components/NumberInput/helpers';
import { Input } from 'ui/styled';
var NumberInput = function (_a) {
    var _b = _a.placeHolder, placeHolder = _b === void 0 ? '' : _b, maxLength = _a.maxLength, type = _a.type, _c = _a.initialValue, initialValue = _c === void 0 ? '' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, formOnchangeValue = _a.onChange // method from ant form, to set value to ant for validation
    ;
    var _e = useState(initialValue || ''), number = _e[0], setNumber = _e[1];
    useEffect(function () {
        if (initialValue) {
            setNumber(initialValue);
        }
    }, [initialValue]);
    var handleChange = function (event) {
        var value = event.target.value;
        var isValidValue = validateNumber(value);
        if (isValidValue) {
            if (formOnchangeValue)
                formOnchangeValue(value);
            setNumber(value);
        }
    };
    return (_jsx(Input, { value: number, "data-test": "".concat(type, "InputString"), placeholder: placeHolder, maxLength: maxLength, onChange: handleChange, disabled: disabled }));
};
export default memo(NumberInput);
